export const tr = {
    'desktop-view': 'todo',
    'mobile-view': 'todo',
    'new-tab-view': 'todo'
};
